import { ClientException, ClientExceptionConstructor } from './client-exception';

export class NfcTagReadOnlyException extends ClientException implements ClientExceptionConstructor {
  constructor(message?: string, error?: Error) {
    super(message, error);
    this.name = 'NfcTagReadOnlyException';
  }

  static fromError(error: Error): NfcTagReadOnlyException {
    return new this(error.message, error);
  }
}
